/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExportFileResponse } from '../models/ExportFileResponse';
import type { GoaInputs } from '../models/GoaInputs';
import type { OrgNameDto } from '../models/OrgNameDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DataExtractService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns ExportFileResponse OK
     * @throws ApiError
     */
    public extractForGoa(
        requestBody?: GoaInputs,
    ): CancelablePromise<ExportFileResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DataExtract/ExtractForGoa',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get only the housing orgs that they can extract data for.
     * @returns OrgNameDto OK
     * @throws ApiError
     */
    public getOrgNames(): CancelablePromise<Array<OrgNameDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DataExtract/GetOrgNames',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
